import { FC } from "react"
import { DiaryFiltersItem, DiaryFiltersItemTitle } from "./styles"
import { SearchListItem } from "shared/ui/searchList/style"
import { DiaryFiltersFormValues } from "shared/types";

type DiaryAttachmentsFilterProps = {
  formValues: Partial<DiaryFiltersFormValues>;
  hideHead?: boolean;
  setHasAttachments: (value: boolean) => void;
}

export const DiaryAttachmentsFilter: FC<DiaryAttachmentsFilterProps> = ({
  formValues,
  hideHead,
  setHasAttachments
}) => {
  return (
    <DiaryFiltersItem>
      {!hideHead && 
      <DiaryFiltersItemTitle>
        <span>Вложения</span>
      </DiaryFiltersItemTitle>
      }
      <SearchListItem onClick={() => setHasAttachments(true)} $isActive={formValues.hasAttachments === true}>Есть</SearchListItem>
      <SearchListItem onClick={() => setHasAttachments(false)} $isActive={formValues.hasAttachments === false}>Отсутствуют</SearchListItem>
    </DiaryFiltersItem>
  )
}